import classNames from 'classnames';
import React from 'react';
import { IconProps } from '../types/icon';
import styles from './icon.module.sass';

export function IconTwitter({ className }: IconProps) {
  return (
    <svg
      className={classNames(styles.icon, className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <title>X</title>
      <path
        d="M8.66048 19.3091C15.4479 19.3091 19.1607 13.6842 19.1607 8.80883C19.1607 8.64926 19.1607 8.48969 19.1607 8.33012C19.8833 7.80865 20.5067 7.16208 21.0015 6.42098C20.3271 6.71541 19.6126 6.90749 18.8815 6.99087C19.6528 6.52945 20.2301 5.80333 20.5057 4.94781C19.781 5.37877 18.9878 5.68235 18.1606 5.84539C17.0119 4.6321 15.1933 4.33789 13.7207 5.12714C12.2481 5.91638 11.4861 7.59371 11.8604 9.222C8.89343 9.07317 6.1291 7.67184 4.25522 5.36668C3.28081 7.05318 3.77891 9.20621 5.39501 10.2934C4.80861 10.2752 4.23509 10.1169 3.72238 9.83178V9.87737C3.72714 11.6327 4.96332 13.1438 6.68296 13.4962C6.13931 13.6435 5.56921 13.665 5.01603 13.5589C5.50143 15.0611 6.88554 16.0906 8.46387 16.1234C7.15709 17.1494 5.54337 17.7064 3.88195 17.7048C3.58765 17.7038 3.29366 17.6857 3.00146 17.6507C4.68972 18.7348 6.65413 19.3104 8.66048 19.3091Z"
        fill="black"
      />
    </svg>
  );
}
